import React, { useState, useEffect } from 'react';
import './HistoriquePaiements.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import { BookIcon, DocumentIcon, FoodIcon, BusIcon, MoneyIcon } from '../../components/Icons';

function HistoriquePaiements() {
  const [paiements, setPaiements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchPaiements();
  }, []);

  const fetchPaiements = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('http://127.0.0.1:8000/api/v1/paiements/tous', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setPaiements(data.paiements || []);
      }
    } catch (err) {
      console.error('Erreur lors du chargement des paiements:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatMontant = (montant) => {
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(montant);
  };

  const getPaymentIcon = (type) => {
    const iconProps = { size: 20, color: "#0078D7" };
    const icons = {
      scolarite: <BookIcon {...iconProps} />,
      inscription: <DocumentIcon {...iconProps} />,
      examen: <DocumentIcon {...iconProps} />,
      cantine: <FoodIcon {...iconProps} />,
      transport: <BusIcon {...iconProps} />,
      autre: <MoneyIcon {...iconProps} />
    };
    return icons[type] || <MoneyIcon {...iconProps} />;
  };

  const filteredPaiements = paiements.filter(p => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      p.etudiant?.nom?.toLowerCase().includes(search) ||
      p.etudiant?.prenom?.toLowerCase().includes(search) ||
      p.etudiant?.matricule?.toLowerCase().includes(search) ||
      p.reference?.toLowerCase().includes(search) ||
      p.type?.toLowerCase().includes(search)
    );
  });

  const totalPaye = paiements.reduce((sum, p) => sum + parseFloat(p.montant), 0);

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Historique des Paiements" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="historique-admin-content">
            <div className="page-header">
              <p className="page-subtitle">Tous les paiements effectués par les parents</p>
            </div>

            {/* Stats */}
            <div className="stats-cards">
              <div className="stat-card">
                <div className="stat-icon"><MoneyIcon size={36} color="#fff" /></div>
                <div className="stat-info">
                  <div className="stat-label">Total Reçu</div>
                  <div className="stat-value">{formatMontant(totalPaye)} FCFA</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon"><DocumentIcon size={36} color="#fff" /></div>
                <div className="stat-info">
                  <div className="stat-label">Nombre de Paiements</div>
                  <div className="stat-value">{paiements.length}</div>
                </div>
              </div>
            </div>

            {/* Recherche */}
            <div className="search-section">
              <input
                type="text"
                placeholder="Rechercher par nom, matricule, référence ou type..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>

            {/* Table */}
            <div className="paiements-card">
              {loading ? (
                <div className="loading-state">Chargement...</div>
              ) : filteredPaiements.length === 0 ? (
                <div className="empty-state">Aucun paiement trouvé</div>
              ) : (
                <div className="paiements-table">
                  <div className="table-header">
                    <div>Élève</div>
                    <div>Type</div>
                    <div>Référence</div>
                    <div>Montant</div>
                    <div>Date & Heure</div>
                    <div>Mode</div>
                  </div>
                  <div className="table-body">
                    {filteredPaiements.map((paiement) => (
                      <div key={paiement.id} className="table-row">
                        <div className="col-etudiant">
                          <div className="etudiant-name">
                            {paiement.etudiant?.nom} {paiement.etudiant?.prenom}
                          </div>
                          <div className="etudiant-matricule">
                            {paiement.etudiant?.matricule}
                          </div>
                          <div className="etudiant-classe">
                            {paiement.etudiant?.classe?.nom || 'N/A'}
                          </div>
                        </div>
                        <div className="col-type">
                          <span className="payment-icon">{getPaymentIcon(paiement.type)}</span>
                          <span className="type-label">{paiement.type}</span>
                        </div>
                        <div className="col-reference">
                          {paiement.reference}
                        </div>
                        <div className="col-montant">
                          {formatMontant(paiement.montant)} FCFA
                        </div>
                        <div className="col-date">
                          {formatDate(paiement.date_paiement)}
                        </div>
                        <div className="col-mode">
                          <span className="mode-badge">{paiement.mode_paiement}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default HistoriquePaiements;
